/**************************************************
 * Nombre:       Tarjeta_Premios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useContext} from "react";
import {usuarioContext} from "../../App";
import Tarjeta_Premio_Ver from "../Tarjetas/Tarjeta_Premio_Ver";
import {metasDos, metasTres, metasUno} from "../../Constantes";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';


const Tarjeta_Premios = () => {
    const cData = useContext(usuarioContext)

    let metas = [...metasUno, ...metasDos, ...metasTres]

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Splide
                    aria-label="My Favorite Images" style={{width: '100%'}}
                    options={{
                        autoplay: true,
                        speed: 1500,
                        rewind: true,
                        perPage: 1,
                        arrows: true,
                        pagination: false,
                        width: '100%',
                        drag: 'false',
                        interval: 5000,
                        noDrag: true,
                       // type: 'fade'
                        gap: 16

                    }}
                >

                    {metas.map((it, index) => {
                        return (
                            <SplideSlide key={`qte${index}`}>
                                <Tarjeta_Premio_Ver item={it}/>
                            </SplideSlide>
                        )
                    })}


                </Splide>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Premios
